export class RejectReason {
  receipt_datetime_search = false;
  fee_search = false;
  age_search = false;
  ncc_search = false;
  interview_times_search = false;
  employment_status_search = false;
  country_of_citizenship_search = false;
  begin_at_search = false;
  commute_search = false;
  bp_rank_search = false;
  mail_from_search = false;
  user_focus_mail_search = false;
  unread_search = false;
  non_transmited_number_search = false;
  work_location_search = false;
  belong_to_own_company_search = false;
  fulltext_search = false;
  sender_hash_id_search = false;
  best_condition_search = false;

  constructor(hash: any) {
    Object.assign(this, hash);
  }
}

export class MailRejectReasons {
  constructor(hash: any) {
    hash = hash || {};
    Object.keys(hash).forEach(key => {
      this[key] = new RejectReason(hash[key]);
    });
  }
}
